import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Banner, Sizes } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { showModalAction } from 'Store/modules/app/actions';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchGetCustomers, useFetchGetPlans } from 'Containers/Plans/hooks';
import CustomTransition from 'Components/CustomTransition';
import { FRONT_PLANS, parsePlans, PLAN_FLEX_LITE, plansNameMapping } from 'Constants/plans';
import { proModalOptions } from './utils';

const UpgradeToProBanner = (): JSX.Element | null => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const dispatch = useDispatch();
  const { data: customer, isLoading } = useFetchGetCustomers(true);
  const { data: plans, isLoading: isLoadingPlans } = useFetchGetPlans();
  const plan = useMemo(
    () =>
      customer && customer.activePlan
        ? customer.activePlan.name === PLAN_FLEX_LITE
          ? FRONT_PLANS.FLEX_LITE
          : plansNameMapping(customer.activePlan.name)
        : FRONT_PLANS.BASIC,
    [customer]
  );
  if (isLoading || isLoadingPlans) return null;
  if (plan !== FRONT_PLANS.BASIC) return null;

  const handleClick = (): void => {
    const filterPlanPro = plans?.find(item => parsePlans(item.name) === FRONT_PLANS.PRO);
    dispatch(
      showModalAction({
        options: {
          ...proModalOptions,
          data: {
            ...proModalOptions.data,
            upsellingProps: filterPlanPro,
          },
        },
      })
    );
  };

  return (
    <CustomTransition start>
      <Banner
        id="upgrade-to-pro"
        label={t('UpgradeToProBanner.label')}
        description={t('UpgradeToProBanner.description')}
        size={Sizes.M}
        layout="embed"
        position="vertically"
        mode="warning"
        hasClose
        buttonLabel={t('UpgradeToProBanner.buttonLabel')}
        onClick={handleClick}
        titleSize={Sizes.S}
      />
    </CustomTransition>
  );
};

export default UpgradeToProBanner;
